import React, { useState, useEffect, useCallback } from 'react';
import industryDataset from './data/IndustryDataset';
import "../styles/steps.css";

const TechStack = ({ formData, updateFormData, setStepValidation, stepNumber }) => {
    const [error, setError] = useState('');
    const [newTech, setNewTech] = useState('');
    const [defaultTech, setDefaultTech] = useState([]); // Default tech from IndustryDataset
    const [selectedTech, setSelectedTech] = useState([]); // User-selected tech (default + custom)

    // Load default technologies when industry changes
    useEffect(() => {
        if (formData.industry && industryDataset[formData.industry]) {
            const defaultTechFromDataset = industryDataset[formData.industry]?.techStack || [];
            setDefaultTech(defaultTechFromDataset);
            //console.log("FB tech ", formData.isFBTechStack);
            //console.log("selected tech ", selectedTech);
            if (formData.isFBTechStack) formData.techStack = [];
            //console.log("formData.techStack ", formData.techStack);
            // Initialize selectedTech with any pre-selected tech from formData
            if (formData.techStack.length > 0) {
                setSelectedTech(formData.techStack);
            } else {
                setSelectedTech([]);
            }
        }
    }, [formData.industry]);

    // Update formData when selectedTech changes
    useEffect(() => {
        updateFormData({ techStack: selectedTech });
    }, [selectedTech, updateFormData]);

    // Validation Function
    const validateFields = useCallback((nextClicked = false) => {
        let errorMessage = '';

        if (nextClicked && selectedTech.length === 0) {
            errorMessage = 'Please select at least one technology or add a custom technology.';
        }

        setError(errorMessage);
        return errorMessage === ''; // Return true if valid
    }, [selectedTech]);

    useEffect(() => {
        if (setStepValidation) {
            setStepValidation(stepNumber, validateFields);
        }
    }, [setStepValidation, stepNumber, validateFields]);

    // Handle Technology Selection (Check/Uncheck)
    const handleTechChange = (tech) => {
        const isSelected = selectedTech.includes(tech);
        const updatedTechStack = isSelected
            ? selectedTech.filter(t => t !== tech) // Uncheck: Remove from selected list
            : [...selectedTech, tech]; // Check: Add to selected list

        formData.isFBTechStack = false;
        setSelectedTech(updatedTechStack);
    };

    // Handle Adding a Custom Technology
    const handleAddCustomTech = () => {
        if (!newTech.trim()) {
            alert("Please enter a valid technology name.");
            return;
        }

        if (selectedTech.includes(newTech)) {
            alert("This technology already exists in the selected list.");
            return;
        }

        formData.isFBTechStack = false;
        setSelectedTech([...selectedTech, newTech]);
        setNewTech('');
    };

    return (
        <div className="step-container">
            <p className="step-description">
            A well-defined tech stack helps plan development effort, compatibility, and resource needs more effectively. Choose the technology stack for your project. This step is most relevant for Software Development, where selecting the right programming languages, frameworks, and tools is essential. If your project is not software-related, simply select 'N/A' and proceed to the next step.
                
            </p>
            <br></br>
            {/* Display Default Technologies */}
            <div className="tech-list">
                {defaultTech.map((tech, index) => {
                    const isChecked = selectedTech.includes(tech); // Check if selected
                    return (
                        <div key={index} className="tech-item">
                            <label className="tech-label">
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={() => handleTechChange(tech)}
                                    className="tech-checkbox"
                                />
                                <span>{tech}</span>
                            </label>
                        </div>
                    );
                })}
            </div>

            {/* Display Selected Custom Technologies */}
            <div className="tech-list">
                {selectedTech
                    .filter(tech => !defaultTech.includes(tech)) // Show only custom ones
                    .map((tech, index) => (
                        <div key={`custom-${index}`} className="tech-item">
                            <label className="tech-label">
                                <input
                                    type="checkbox"
                                    checked
                                    onChange={() => handleTechChange(tech)}
                                    className="tech-checkbox"
                                />
                                <span>{tech}</span>
                            </label>
                        </div>
                    ))}
            </div>

            {/* Add Custom Technology Section */}
            <div className="add-custom-tech">
                <h3 className="section-title">Add Custom Technology:</h3>
                <div className="add-tech-stack">
                    <input
                        type="text"
                        value={newTech}
                        onChange={(e) => setNewTech(e.target.value)}
                        placeholder="Technology Name"
                        className="custom-tech-input"
                    />
                    <button onClick={handleAddCustomTech} className="add-button">
                        Add Technology
                    </button>
                </div>
            </div>

            {/* Show error message inside the step if validation fails */}
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
    );
};

export default TechStack;